import { c as _c } from "react/compiler-runtime";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { GroupCardState } from "./GroupCard";
import GroupCardContent from "./GroupCardContent";
import GroupCardHeader from "./GroupCardHeader";
export default function GroupCardView(t0) {
  const $ = _c(12);
  const {
    group,
    haveActiveGroupVoteAll,
    setState,
    onEditClick,
    userPlaceholder,
    titlePlaceholder
  } = t0;
  let t1;
  if ($[0] !== group || $[1] !== onEditClick || $[2] !== userPlaceholder) {
    t1 = <GroupCardHeader group={group} onEditClick={onEditClick} userPlaceholder={userPlaceholder} />;
    $[0] = group;
    $[1] = onEditClick;
    $[2] = userPlaceholder;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== group || $[5] !== haveActiveGroupVoteAll || $[6] !== setState || $[7] !== titlePlaceholder) {
    t2 = <div className="tw-pt-2 tw-flex tw-flex-col tw-h-full"><GroupCardContent group={group} haveActiveGroupVoteAll={haveActiveGroupVoteAll} setState={setState} titlePlaceholder={titlePlaceholder} /></div>;
    $[4] = group;
    $[5] = haveActiveGroupVoteAll;
    $[6] = setState;
    $[7] = titlePlaceholder;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className="tw-flex tw-flex-col tw-h-full">{t1}{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}